import { Component, Input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-settings-icon',
  templateUrl: './settings-icon.component.html',
  styleUrls: ['./settings-icon.component.scss']
})
export class SettingsIconComponent {

  /********* Inputs *********/
  /**
   * @description svg width
   */
  @Input({ alias: 'width' }) public Width: string = null

  /**
   * @description svg height
   */
  @Input({ alias: 'height' }) public Height: string = null
    
}
